import { createContext, useContext } from 'react';
import { Property } from '@model';

export type WishlistModel = {
  wishlist: Property[];
  addToWishlist: (property: Property) => void;
  removeFromWishlist: (id: number) => void;
  isInWishlist: (id: number) => boolean;
  hideWishlistModal: () => void;
  wishlistModalProperty: Property | undefined;
};

export const WishlistContext = createContext<WishlistModel>({
  wishlist: [],
  addToWishlist: () => {},
  removeFromWishlist: () => {},
  isInWishlist: () => false,
  hideWishlistModal: () => {},
  wishlistModalProperty: undefined,
});

export const useWishlist = () => useContext(WishlistContext);
